import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

export type CycleBreakdown = {
  base_earnings: number;
  ranking_bonus: number;
  group_bonus: number;
  race_bonus: number;
  sanctions: number;
};

export type CycleTotal = {
  period_start: string;
  period_end: string;
  total_eur: number;
  breakdown: CycleBreakdown;
  collectors_count: number;
  total_leads: number;
  sanctions_count: number;
};

export function useCycleTotals(enabled: boolean) {
  return useQuery({
    queryKey: ['admin-cycle-totals'],
    queryFn: (): Promise<{ cycles: CycleTotal[] }> =>
      pb.send('/api/admin/payments/cycle-totals?limit=20', { method: 'GET' }),
    enabled,
    staleTime: 60_000,
  });
}
